// Minimal modal dialog used by export / songs / share (docs/07).

export interface Dialog {
  element: HTMLElement;
  body: HTMLElement;
  open(): void;
  close(): void;
}

export function createDialog(title: string): Dialog {
  const overlay = document.createElement("div");
  overlay.className = "dialog-overlay";
  overlay.hidden = true;

  const panel = document.createElement("div");
  panel.className = "dialog";
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-modal", "true");
  panel.setAttribute("aria-label", title);

  const head = document.createElement("div");
  head.className = "dialog__head";
  const heading = document.createElement("h2");
  heading.className = "dialog__title";
  heading.textContent = title;
  const close = document.createElement("button");
  close.type = "button";
  close.className = "dialog__close";
  close.textContent = "✕";
  close.setAttribute("aria-label", "Close");
  head.append(heading, close);

  const body = document.createElement("div");
  body.className = "dialog__body";

  panel.append(head, body);
  overlay.append(panel);

  const api: Dialog = {
    element: overlay,
    body,
    open() {
      overlay.hidden = false;
    },
    close() {
      overlay.hidden = true;
    },
  };

  close.addEventListener("click", () => api.close());
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) api.close();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !overlay.hidden) api.close();
  });

  return api;
}
